export let QueryType = /*#__PURE__*/function (QueryType) {
  QueryType["GET"] = "GET";
  QueryType["UPDATE"] = "UPDATE";
  QueryType["LIST"] = "LIST";
  QueryType["CREATE"] = "CREATE";
  QueryType["DELETE"] = "DELETE";
  QueryType["COUNT"] = "COUNT";
  QueryType["TRIGGER_EVENT"] = "TRIGGER_EVENT";
  return QueryType;
}({});
export let QueryKeys = /*#__PURE__*/function (QueryKeys) {
  QueryKeys["ASSISTANT_PROPERTIES"] = "assistantProperties";
  QueryKeys["GENERATE_PERSONALITY"] = "generatePersonality";
  QueryKeys["GENERATE_INTRO_MESSAGE"] = "generateIntroMessage";
  QueryKeys["MEETING_TYPES"] = "meetingTypes";
  QueryKeys["BUSINESSES"] = "businesses";
  QueryKeys["BUSINESS_PROPERTIES"] = "businessProperties";
  QueryKeys["LINKED_ACCOUNTS"] = "linkedAccounts";
  QueryKeys["TASKS"] = "tasks";
  QueryKeys["ACTIONS"] = "actions";
  QueryKeys["RECURRING_SCHEDULES"] = "recurringSchedules";
  QueryKeys["USER_DATA"] = "userData";
  QueryKeys["USER_CONVERSATION"] = "userConversation";
  QueryKeys["SERVICES_FACADE"] = "servicesFacade";
  QueryKeys["ENRICHED_ACTION"] = "enrichedAction";
  QueryKeys["CONTACTS"] = "contacts";
  QueryKeys["CALENDAR_OAUTH"] = "calendarOAuth";
  QueryKeys["CALENDAR_INDIVIDUAL_OAUTH"] = "calendarIndividualOAuth";
  QueryKeys["CONTACT_CALENDAR_OAUTH"] = "contactCalendarOAuth";
  QueryKeys["MEDIA_SITE_FILES"] = "mediaSiteFiles";
  QueryKeys["HIGHLIGHTS"] = "highlights";
  QueryKeys["CONVERSATION_HISTORY"] = "conversationHistory";
  QueryKeys["GUIDELINES"] = "guidelines";
  QueryKeys["PROVIDER_GUIDELINES"] = "guidelines";
  QueryKeys["PROVIDERS"] = "providers";
  QueryKeys["ENRICHED_MEETING_TYPES"] = "enrichedMeetingTypes";
  QueryKeys["GROUPED_SERVICES"] = "groupedServices";
  QueryKeys["PARTICIPANTS"] = "participants";
  QueryKeys["RECOMMENDATIONS"] = "recommendations";
  QueryKeys["METRICS"] = "metrics";
  QueryKeys["MEETINGS"] = "meetings";
  QueryKeys["DIGEST"] = "digest";
  QueryKeys["RECIPIENT"] = "recipient";
  QueryKeys["CONVERSATION"] = "conversation";
  QueryKeys["USER_VERIFICATION"] = "userVerification";
  QueryKeys["ROUTINE"] = "routine";
  QueryKeys["ENRICHED_CONTEXT"] = "enrichedContext";
  QueryKeys["METASITE"] = "metasite";
  return QueryKeys;
}({});
export const generateQueryKey = function (key, type) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }
  return [key, type, ...args];
};
//# sourceMappingURL=generateQueryKey.js.map